<template>
  <div
    :id="question.id"
    class="row">
    <div
      :class="`col-4 py-2 ${question.answered || mode === 'edit' ? '' : 'text-muted'}`">
      {{question.text}}
    </div>

    <div class="col-8">
      <div v-for="field in question.fields" :key="field.id">
        <QuestionnaireField
          v-if="typeof field.answer !== 'undefined' || mode === 'edit'"
          :field="field"
          :mode="mode"
          :comment-answer="commentAnswer"
          :update-answer="updateAnswer"
          :userCanEdit="userCanEdit"
          :userCanComment="userCanComment" />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionnaireField from './Field';

export default {
  name: 'QuestionnaireQuestion',

  components: {QuestionnaireField},

  props: ['question', 'mode', 'commentAnswer', 'updateAnswer', 'userCanEdit', 'userCanComment'],

  data() {
    return {};
  },
};
</script>
